'use client';
var classes = {"levelsGroup":"m-30b26e33"};

export { classes as default };
//# sourceMappingURL=LevelsGroup.module.css.mjs.map
